<template>
  <footer class="footer footer-theme position-relative">
    <b-container class="mb-5">
      <b-row>
        <b-col>
          <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/tuev-nord-transfer/`" class="d-block">
            <div class="pb-1 pb-sm-3 h-100  text-primary">
              <img :src="require('@/assets/img/logo/logo-ragtp.svg')" alt="talenpool" class="img img-fluid logo-header text-primary" />
            </div>
          </a>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <div class="footer-top">
        <b-row>
          <b-col lg="4" md="6" sm="12" class="footer-column">
            <div class="font-medium text-uppercase hyphens-manual footer-title mb-3">
              Kontakt &amp; Services
            </div>
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links1" :key="`links1-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="footer-column">
            <div class="font-medium text-uppercase hyphens-manual footer-title mb-3">
              Unternehmen
            </div>
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links2" :key="`links2-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="footer-column">
            <div class="font-medium text-uppercase hyphens-manual footer-title mb-3">
              Unsere Leistungen
            </div>
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links3" :key="`links3-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <div class="footer-center">
      <b-container>
        <p>TÜV NORD ⋅ Am TÜV 1 ⋅ 30519 Hannover</p>
      </b-container>
    </div>
    <b-container>
      <div class="footer-bottom">
        <b-row>
          <b-col>
            <div class="clearfix">
              <div class="copyright d-flex align-items-center justify-content-between">
                <p class="m-0">
                  © {{ new Date().getFullYear() }} TÜV NORD
                </p>

                <ul class="d-flex flex-row flex-wrap footer-co m-0">
                  <li class="ml-0">
                    <a href="https://www.youtube.com/user/tuevnordgroup" target="_blank" rel="noopener noreferrer"
                       aria-label="youtube" class="d-flex p-2">
                      <i role="img" aria-label="youtube" class="d-flex">
                        <svg class="flex w-full h-auto">
                          <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M22 12s0 3.2563-.4188 4.8125a2.503 2.503 0 0 1-1.7687 1.7687C18.25 19 12 19 12 19s-6.2562 0-7.8125-.4188a2.504 2.504 0 0 1-1.7687-1.7687C2 15.25 2 12 2 12s0-3.2562.4188-4.8125a2.504 2.504 0 0 1 1.7687-1.7687C5.75 5 12 5 12 5s6.2563 0 7.8125.4188a2.504 2.504 0 0 1 1.7687 1.7687C22 8.75 22 12 22 12m-12 3 5.1937-3L10 9z"/>
                        </svg>
                      </i>
                    </a>
                  </li>
                  <li class="ml-3">
                    <a href="https://www.linkedin.com/company/t-v-nord-group" target="_blank"
                         rel="noopener noreferrer"
                          aria-label="linkedin"
                         class="d-flex p-2">
                      <i role="img" aria-label="linkedin" class="d-flex">
                        <svg class="flex w-full h-auto">
                          <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M22 22h-4.1438v-6.4997c0-1.5466-.0249-3.5441-2.1562-3.5441-2.1562 0-2.4875 1.6906-2.4875 3.4314V22H9.0687V8.6374h3.9751v1.8285H13.1c.8125-1.3839 2.3188-2.2167 3.925-2.1603 4.2 0 4.9687 2.7677 4.9687 6.3619zM4.4063 6.809C3.0875 6.809 2 5.7195 2 4.4045 2 3.0833 3.0875 2 4.4 2c1.3187 0 2.4 1.0896 2.4 2.4045.0063 1.3212-1.0812 2.4045-2.3937 2.4045M6.475 22H2.3313V8.6374H6.475z"/>
                        </svg>
                      </i>
                    </a>
                  </li>
                  <li class="ml-3">
                    <a href="https://www.instagram.com/tuevnordgroup/" target="_blank" rel="noopener noreferrer"
                       aria-label="instagram" class="d-flex p-2">
                      <i role="img" aria-label="instagram" class="d-flex">
                        <svg class="flex w-full h-auto">
                          <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M12 3.8c2.6687 0 2.9875.0125 4.0437.0563.975.0437 1.5063.2062 1.8563.3437.4687.1812.8.4 1.15.75s.5687.6812.75 1.15c.1375.35.3.8813.3438 1.8563.05 1.0562.0562 1.3687.0562 4.0437s-.0125 2.9875-.0562 4.0437c-.0438.975-.2063 1.5063-.3438 1.8563-.1813.4687-.4.8-.75 1.15s-.6813.5687-1.15.75c-.35.1375-.8813.3-1.8563.3438-1.0562.05-1.3687.0562-4.0437.0562s-2.9875-.0125-4.0437-.0562C6.9813 20.1 6.45 19.9375 6.1 19.8c-.4687-.1813-.8-.4-1.15-.75s-.5688-.6813-.75-1.15c-.1375-.35-.3-.8813-.3437-1.8563C3.8125 14.9875 3.8 14.6687 3.8 12s.0125-2.9875.0563-4.0437C3.9 6.9813 4.0625 6.45 4.2 6.1c.1812-.4687.4-.8.75-1.15s.6812-.5688 1.15-.75c.35-.1375.8813-.3 1.8563-.3437C9.0125 3.8125 9.3313 3.8 12 3.8M12 2c-2.7187 0-3.0563.0125-4.125.0625-1.0625.0438-1.7875.2125-2.425.4625-.6562.2563-1.2187.6-1.7688 1.1563-.5562.55-.9 1.1125-1.1562 1.7687-.25.6375-.4187 1.3625-.4625 2.425C2.0125 8.9437 2 9.2813 2 12s.0125 3.0563.0625 4.125c.05 1.0625.2188 1.7937.4625 2.425.2563.6562.6 1.2125 1.1563 1.7688.5562.5562 1.1125.9 1.7687 1.1562.6375.25 1.3625.4187 2.425.4625C8.9437 21.9875 9.2813 22 12 22s3.0563-.0125 4.125-.0625c1.0625-.05 1.7937-.2187 2.425-.4625.6562-.2562 1.2125-.6 1.7688-1.1562.5562-.5563.9-1.1126 1.1562-1.7688.25-.6375.4187-1.3625.4625-2.425.05-1.0687.0625-1.4062.0625-4.125s-.0125-3.0563-.0625-4.125c-.05-1.0625-.2187-1.7937-.4625-2.425-.2562-.6562-.6-1.2125-1.1562-1.7688-.5563-.5562-1.1126-.9-1.7688-1.1562-.6375-.25-1.3625-.4187-2.425-.4625C15.0563 2.0125 14.7188 2 12 2"/>
                          <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M12.0003 6.8623c-2.8375 0-5.1375 2.3-5.1375 5.1375s2.3 5.1375 5.1375 5.1375 5.1375-2.3 5.1375-5.1375-2.3-5.1375-5.1375-5.1375m0 8.4688c-1.8438 0-3.3313-1.4938-3.3313-3.3313 0-1.8437 1.4938-3.3313 3.3313-3.3313 1.8437 0 3.3312 1.4938 3.3312 3.3313 0 1.8438-1.4875 3.3313-3.3312 3.3313m5.3374-7.4687c.6627 0 1.2-.5373 1.2-1.2s-.5373-1.2-1.2-1.2-1.2.5373-1.2 1.2.5373 1.2 1.2 1.2"/>
                        </svg>
                      </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </footer>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';

interface LinkItem {
  text: string
  link?: string
  hasIcon?: boolean
}

@Component
export default class FooterComponent extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de'; // AppModule.language;
  }

  get links1() {
    const resultArr: LinkItem[] = [
      {
        text: 'Kontakt',
        link: `https://www.tuev-nord.de/${this.lang}/kontakt-service/kontakt/`,
      },
      {
        text: 'TÜV NORD weltweit',
        link: `https://www.tuev-nord.de/${this.lang}/`,
      },
      {
        text: 'Allgemeine Geschäftsbedingungen',
        link: `https://www.tuev-nord.de/${this.lang}/kontakt-services/allgemeine-geschaeftsbedingungen/`,
      },
      {
        text: 'TÜV NORD Newsletter abonnieren',
        link: `https://www.tuev-nord.de/${this.lang}/newsletter-von-tuev-nord/`,
      },
    ];
    return resultArr;
  }

  get links2() {
    const resultArr: LinkItem[] = [
      {
        text: 'Datenschutzerklärung', // 'Plattformen',
        link: `https://www.tuev-nord.de/${this.lang}/footer-unternehmen/datenschutzerklaerung/`,
      },
      {
        text: 'Impressum',
        link: `https://www.tuev-nord.de/${this.lang}/unternehmen/impressum/`,
      },
      {
        text: 'Erklärung zur Barrierefreiheit',
        link: `https://www.tuev-nord.de/${this.lang}/footer-unternehmen/erklaerung-zur-barrierefreiheit/`,
      },
    ];
    return resultArr;
  }

  get links3() {
    const resultArr: LinkItem[] = [
      {
        text: 'TÜV NORD GROUP',
        link: `https://www.tuev-nord-group.com/${this.lang}/`,
      },
    ];
    return resultArr;
  }

  get links4() {
    const resultArr: LinkItem[] = [
      {
        text: 'Deutschtraining', // 'DaF/DaZ',
        link: `https://www.tuev-nord.de/${this.lang}/Deutschtraining/index.php`,
      },
      {
        text: 'Deutschlernplattform',
        link: `https://www.tuev-nord.de/${this.lang}/Deutschtraining/Deutschlernplattform.php`,
      },
      {
        text: 'Deutschlehrkräfte',
        link: `https://www.tuev-nord.de/${this.lang}/Deutschtraining/Deutschlehrkraefte.php`,
      },
      {
        text: 'Deutschlerninhalte',
        link: `https://www.tuev-nord.de/${this.lang}/Deutschtraining/Deutschlerninhalte.php`,
      },
      {
        text: 'Deutschprüfungen',
        link: `https://www.tuev-nord.de/${this.lang}/Deutschtraining/Deutschpruefungen.php`,
      },
    ];
    return resultArr;
  }

  get links5() {
    const resultArr: LinkItem[] = [
      {
        text: this.translations[14997],
        link: '/',
      },
      {
        text: this.translations[15401],
        link: `https://www.tuev-nord.de/${this.lang}/Job-Talent-Space/Auf-einen-Blick.php`,
      },
      {
        text: 'FAQ',
        link: `https://www.tuev-nord.de/${this.lang}/Job-Talent-Space/FAQ.php`,
      },
    ];
    return resultArr;
  }

  get links6() {
    const resultArr: LinkItem[] = [
      {
        text: 'Über uns',
        link: `https://www.tuev-nord.de/${this.lang}/Ueber-uns/index.php`,
      },
    ];
    return resultArr;
  }

  get links7() {
    const resultArr: LinkItem[] = [
      {
        text: 'Kontakt',
        link: `https://www.tuev-nord.de/${this.lang}/Kontakt/index.php`,
      },
      {
        text: 'So erreichen Sie uns',
        link: `https://www.tuev-nord.de/${this.lang}/Kontakt/index.php`,
      },
      {
        text: 'Impressum',
        link: `https://www.tuev-nord.de/${this.lang}/Kontakt/impressum.php`,
      },
      {
        text: 'Kontaktformular',
        link: `https://www.tuev-nord.de/${this.lang}/Kontakt/form.php`,
      },
      {
        text: 'Datenschutz',
        link: `https://www.tuev-nord.de/${this.lang}/Kontakt/Datenschutz.php`,
      },
    ];
    return resultArr;
  }
}
</script>
<style lang="scss" scoped>
[theme="default"] {
  .footer-title {
    color: #CCD2F6;
    font-size: 14px;
  }

  .footer-theme {
    background: #001ed2;
    padding: 10px 0  15px 0;
    .pull-left {
      float: left;
    }
    .pull-right {
      float: right;
    }
    a {
      text-decoration: none;
      transition: all 500ms ease;
      -moz-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      -ms-transition: all 500ms ease;
      -o-transition: all 500ms ease;
    }
    ul {
      padding: 0;
    }
    h4 {
      color: #ffffff;
      font-size: 20px;
    }
    .footer-center {
      p {
        color: #ffffff;
        font-size: 12px;
      }

      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    .footer-top {
      position: relative;
      display: block;
      padding: 0px 0px 50px 0px;

      p {
        color: #ffffff;
        font-size: 18px;
        line-height: 26px;
        margin-bottom: 26px;
      }
      .widget-content li {
        margin-bottom: 10px;
        a {
          position: relative;
          display: inline-block;
          font-size: 16px;
          line-height: 26px;
          font-weight: 400;
          color: #ffffff;

          &:hover {
            color: #ffffff;
            opacity: 0.8;
            text-decoration: underline;
          }
        }
      }
      .footer-column:nth-child(2) .links-widget {
        margin-left: 0px;
      }
    }
    .footer-bottom {
      position: relative;
      padding-top: 15px;
      .copyright p {
        color: #ffffff;
        line-height: 26px;
        font-size: 16px;
        a {
          display: inline-block;
          color: #ffffff;
          //text-transform: uppercase;
          &:hover {
            color: #ffffff;
            opacity: 0.8;
            text-decoration: underline;
          }
        }
      }
      .footer-nav li {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        &:last-child {
          margin-right: 0px;
          &:before {
            display: none;
          }
        }
        a {
          position: relative;
          display: inline-block;
          font-size: 1rem;
          line-height: 26px;
          font-weight: 300;
          color: #ffffff;
          &:hover {
            color: var(--portal-primary);
          }
        }
        &:before {
          position: absolute;
          content: '.';
          color: #ffffff;
          width: 2px;
          height: 16px;
          top: -3px;
          right: -12px;
        }
      }
    }
  }
  .footer-co {
    a {
      i {
        color: #ffffff;
        width: 25px;
        height: 25px;
      }
      &:hover {
        background: #ffffff;
        border-radius: 50%;
        i {
          color: #001ed2;
        }
      }
    }
  }
}
</style>
